import {ActionType, AutoTextField, FormField} from '../AutoForm/AutoFieldNew';

export type accountFormValues = {
  name: string;
  primaryPhone: string;
  email: string;
  adviser: string;
  owner: string;
  income: string;
  netAssets: string;
  propertyAssets: string;
  accountType: string;
  propositionType: string;
  clientType: string;
  dateBecameClient: string;
  totalAssets: string;
  inHousePlans: string;
  otherPlans: string;
  plans: string;
  liabilities: string;
  ongoingFee: string;
  initialFixedFee: string;
  initialPercentageFee: string;
  leiNumber: string;
  hmrcReference: string;
};

export type contactFormType = {
  id: string;
  name: string;
  primaryPhone: string;
  email: string;
  fullAddress: string;
  gender: string;
  jobTitle: string;
  dob: string;
  familyStatus: string;
  spouseName: string;
  anniversary: string;
};

export const nameField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'name',
  label: 'Account Name',
  type: ActionType.text,
  initialValue: ' ',
};
export const primaryPhoneField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'primaryPhone',
  label: 'Primary phone',
  type: ActionType.text,
  phoneNumber: true,
  private: true,
  initialValue: ' ',
};
export const emailField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'email',
  label: 'Email',
  private: true,
  email: true,
  type: ActionType.text,

  initialValue: ' ',
};
export const adviserField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'adviser',
  label: 'Adviser',
  type: ActionType.text,

  initialValue: ' ',
};
export const ownerField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'owner',
  label: 'Owner',
  type: ActionType.text,
  initialValue: ' ',
};
export const incomeField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'income',
  label: 'Income',
  type: ActionType.text,
  private: true,
  currency: true,
  allowZero: true,
  allowNegative: true,
  initialValue: ' ',
};
export const netAssetsField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'netAssets',
  label: 'Net assets',
  type: ActionType.text,
  private: true,
  currency: true,
  allowZero: true,
  allowNegative: true,
  initialValue: ' ',
};
export const propertyAssetsField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'propertyAssets',
  label: 'Property assets',
  type: ActionType.text,
  currency: true,
  private: true,
  allowZero: true,
  allowNegative: true,
  initialValue: ' ',
};
export const accountTypeField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'accountType',
  label: 'Account type',
  type: ActionType.text,
  initialValue: '',
};
export const leiTypeField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'leiNumber',
  label: 'LEI number',
  type: ActionType.text,
  initialValue: '',
  emptyValText: ' ',
};
export const hmrcTypeField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'hmrcReference',
  label: 'HRMC reference',
  type: ActionType.text,
  initialValue: '',
  emptyValText: ' ',
};
export const propositionTypeField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'propositionType',
  label: 'Proposition type',
  type: ActionType.text,
  initialValue: ' ',
};
export const partnershipTypeField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'businessUnit.partnershipType',
  label: 'Partnership type',
  type: ActionType.text,
  initialValue: ' ',
};
export const businessUnitField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'businessUnit.name',
  label: 'Business unit',
  type: ActionType.text,
  initialValue: '',
};
export const clientTypeField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'clientType',
  label: 'Client type',
  type: ActionType.text,
  initialValue: ' ',
};
export const dateBecameClientField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'dateBecameClient',
  label: 'Date became client',
  type: ActionType.text,
};
export const totalAssetsField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'totalAssets',
  label: 'Total assets',
  type: ActionType.text,
  private: true,
  currency: true,
  allowZero: true,
  allowNegative: true,
};
export const inHousePlansField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'inHousePlans',
  label: 'In house plans',
  type: ActionType.text,
  private: true,
  currency: true,
  allowZero: true,
  allowNegative: true,
};
export const otherPlansField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'otherPlans',
  label: 'Other plans',
  type: ActionType.text,
  private: true,
  currency: true,
  allowZero: true,
  allowNegative: true,
};
export const plansField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'plans',
  label: 'Total of plans',
  type: ActionType.text,
  private: true,
  currency: true,
  allowZero: true,
  allowNegative: true,
};
export const liabilitiesField: AutoTextField = {
  labelOnTop: true,
  readOnly: true,
  canBeEmpty: true,
  id: 'liabilities',
  label: 'Liabilities',
  type: ActionType.text,
  private: true,
  currency: true,
  allowZero: true,
  allowNegative: true,
};
export const initialFixedFeeField: AutoTextField = {
  labelOnTop: true,
  id: 'initialFixedFee',
  label: 'Fixed (£)',
  type: ActionType.text,
  currency: true,
  allowZero: true,
  allowNegative: true,
};
export const initialPercentageFeeField: AutoTextField = {
  labelOnTop: true,
  id: 'initialPercentageFee',
  label: 'Ad valorem (%)',
  type: ActionType.text,
  percent: true,
  decimals: 2,
};

export const contactFormFields: Record<string, FormField> = {
  id: {
    readOnly: true,
    canBeEmpty: true,
    id: 'id',
    label: 'id',
    type: ActionType.text,
    // initialValue: '',
  },
  name: {
    readOnly: true,
    canBeEmpty: true,
    id: 'name',
    label: 'Name',
    type: ActionType.text,
    private: true,
    // initialValue: '',
  },
  primaryPhone: {
    readOnly: true,
    canBeEmpty: true,
    id: 'primaryPhone',
    label: 'Primary phone',
    phoneNumber: true,
    type: ActionType.text,
    private: true,
    // initialValue: '',
  },
  email: {
    readOnly: true,
    canBeEmpty: true,
    id: 'email',
    label: 'Email',
    type: ActionType.text,
    private: true,
    email: true,
  },
  fullAddress: {
    readOnly: true,
    canBeEmpty: true,
    id: 'fullAddress',
    label: 'Address',
    private: true,
    type: ActionType.text,
  },
  gender: {
    readOnly: true,
    canBeEmpty: true,
    id: 'gender',
    label: 'Gender',
    private: true,
    type: ActionType.text,
  },

  jobTitle: {
    readOnly: true,
    canBeEmpty: true,
    id: 'jobTitle',
    label: 'Job title',
    private: true,
    type: ActionType.text,
  },
  dob: {
    readOnly: true,
    canBeEmpty: true,
    id: 'dob',
    label: 'Date of birth',
    private: true,
    type: ActionType.datepicker,
  },
  familyStatus: {
    readOnly: true,
    canBeEmpty: true,
    id: 'familyStatus',
    label: 'Family status',
    private: true,
    type: ActionType.text,
  },
  spouseName: {
    readOnly: true,
    canBeEmpty: true,
    id: 'spouseName',
    label: 'Spouse name',
    private: true,
    type: ActionType.text,
  },
  anniversary: {
    readOnly: true,
    canBeEmpty: true,
    id: 'anniversary',
    label: 'Anniversary',
    private: true,
    type: ActionType.text,
  },
};

export const notificationFormFields: {definitions: Record<string, FormField>} = {
  definitions: {
    message: {
      id: 'message',
      label: 'Message',
      type: ActionType.text,
      initialValue: '',
    },
    text: {
      id: 'text',
      label: 'Text',
      type: ActionType.text,
      initialValue: '',
    },
    url: {
      id: 'url',
      label: 'Url',
      type: ActionType.text,
      initialValue: '',
    },
    toast: {
      id: 'toast',
      label: 'Toast',
      type: ActionType.checkboxToggle,
      initialValue: false,
    },
  },
};
